import ClientsAxios from '../client-axios';
import { handlePostRequest } from './requestHandler';
import { BeneficiaryListResponse, BeneficiaryRegisterResponse } from '../dto/response/beneficiary';

const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

// Registration
export const RegisterBeneficiaryService = (payload: any) =>
    handlePostRequest<BeneficiaryRegisterResponse>('beneficiary/complete-registration', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const PRERegisterBeneficiaryService = (payload: any) =>
    handlePostRequest<BeneficiaryRegisterResponse>('beneficiary/pre-registration', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryUpdateStatusService = (payload: any) =>
    handlePostRequest<BeneficiaryListResponse>('beneficiary/update-status', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Listing
export const FetchBeneficiaryListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchBeneficiaryListUnmaskedService = (payload: any) => handlePostRequest<any>('beneficiary/list-v1', payload, COMMUNITY_HEALTH_CAMP_SERVER);


export const BeneficiaryPastCampaignsAttendedService = (payload: any) =>
    handlePostRequest<any>('beneficiary/camps-attended', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const ActivityListService = (payload: any) =>
    handlePostRequest<any>('activity-log', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchEscalationListService = (payload: any) =>
    handlePostRequest<any>('escalation-action/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Dropdown / ID Lookup
export const BeneficiaryApplicationIDListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/token-no-dropdown', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Details
export const BeneficiaryDetailsService = (payload: any) =>
    handlePostRequest<any>('beneficiary/details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Documents
export const BeneficiaryDocumentListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/document-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryDocumentStoreService = (payload: any) =>
    handlePostRequest<any>('beneficiary/store-document', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

// Comments
export const BeneficiaryCommentStoreService = (payload: any) =>
    handlePostRequest<any>('beneficiary/store-comment', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryCommentListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/comment-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Follow-up
export const FollowUpCreateService = (payload: any) =>
    handlePostRequest<any>('beneficiary-followup/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryFollowupStatusCountService = (payload: any) =>
    handlePostRequest<any>('beneficiary-followup/count', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FollowupStatusWiseListService = (payload: any) =>
    handlePostRequest<any>('beneficiary-followup/status-wise-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Activity-based referral list (non-hospital users)
export const BeneficiaryActivityListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/activity-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Export
export const BeneficiaryExcelsExportService = (payload: any) =>
    handlePostRequest<Blob>('beneficiary/excels-export', payload, COMMUNITY_HEALTH_CAMP_SERVER, {
        responseType: 'blob',
    });
